import React, {Component} from "react";
import {Label, Input} from 'reactstrap';
import { Container } from "./styles/form-address-style";
import { CheckedBox, SeguirSub } from "../telas/styles/estilo_telas";
import FadeIn from 'react-fade-in';
import { getStateJornada } from "../state/actions/jornada_actions";

const {contrato} = getStateJornada();


interface IForm{
    enviado : boolean,
    history : any,
    handleSubmit:(
        endereco : string,
        cep : string,
        uf : string,
        cidade : string
        
    ) => void
  }

interface State{
    unlock : boolean,
    endereco : string,
    cep : string,
    uf : string,
    cidade : string

}

const {REACT_APP_NAME_LECCA} = process.env


export default class FormAddress extends Component<IForm, State> {
    constructor(props : IForm) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onChangeEndereco = this.onChangeEndereco.bind(this)
        this.onChangeCep = this.onChangeCep.bind(this)
        this.onChangeUf = this.onChangeUf.bind(this)
        this.onChangeCidade = this.onChangeCidade.bind(this)

    
        this.state = {
          unlock: true,
          endereco: `${contrato.Cliente.DadosCliente.Enderecos[0].Bairro}, ${contrato.Cliente.DadosCliente.Enderecos[1].Logradouro}, ${contrato.Cliente.DadosCliente.Enderecos[1].Numero}`,
          cep: `${contrato.Cliente.DadosCliente.Enderecos[0].CEP}`,
          uf: contrato.Cliente.DadosCliente.Enderecos[0].UF,
          cidade: contrato.Cliente.DadosCliente.Enderecos[0].Cidade,
      }
      
    }
    onChangeCep(e : React.ChangeEvent<HTMLInputElement>){
      this.setState({
        cep: e.target.value
      })
    }

    onChangeEndereco(e : React.ChangeEvent<HTMLInputElement>){
      this.setState({
        endereco: e.target.value
      })
    }
  
    onChangeUf(e : React.ChangeEvent<HTMLInputElement>){
      this.setState({
        uf: e.target.value
      })
    }
  
    onChangeCidade(e : React.ChangeEvent<HTMLInputElement>){
      this.setState({
        cidade: e.target.value
      })
    }

    handleChange(e : React.ChangeEvent<HTMLInputElement>){
      this.setState({unlock: e.target.checked})
    }





   onSubmit = (e : React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { cep, uf, cidade, endereco} = this.state;

    // eslint-disable-next-line no-lone-blocks
    {/*const fluxo : FluxoType = {
      Selfie: this.state.Selfie,
      ProvaVida: this.state.ProvaVida,
      Identidade: this.state.Identidade,
      Comprovante: this.state.Comprovante,
      Contracheque: this.state.Contracheque
    }*/}

    this.props.handleSubmit( cep, uf, cidade, endereco)

    this.setState({cep: '', uf: '', cidade: '', endereco: ''})
    //this.props.history.push('/')
  }

   render() {

    const {unlock} = this.state;
    //const {enviado} = this.props;
    const {cep, uf, cidade, endereco} = this.state;
    return(
      <FadeIn>
      <Container>
      
      <form onSubmit={this.onSubmit}>
      <section className="inputs-section">
        <div className="inputs">
          <div className="input-column">
              <div className="input-endereco">
                <Label>
                  Endereço
                </Label>

                <Input
                  id="endereco"
                  name="endereco"
                  placeholder= 'Endereço'
                  type="text"
                  onChange={this.onChangeEndereco}
                  value={endereco}
                   />
                  
              </div>
            <div className="input-row">
              <div className="input-city">
              <Label>
                  Cidade
                </Label>

                <Input
                  id="cidade"
                  name="cidade"
                  placeholder="Cidade"
                  type="text"
                  onChange={this.onChangeCidade}
                  value={cidade} />

              </div>

              <div className="input-uf">
              <Label>
                  UF
                </Label>
                  <Input
                    id="uf"
                    name="uf"
                    placeholder={`UF`}
                    type="text"
                    onChange={this.onChangeUf}
                    value={uf} />
              </div>
              <div className="input-cep">
                <Label>
                  CEP
                </Label>
                <Input
                  id="cep"
                  name="cep"
                  placeholder="CEP"
                  type="text"
                  onChange={this.onChangeCep}
                  value={cep} />
              </div>

            </div>

            <div className="check-area">
            <p>Confirmo nos termos da lei 7.115/83 que o endereço informado é da minha residência.
               Estou ciente que qualquer alteração devo comunicar o {REACT_APP_NAME_LECCA}.</p>
            <CheckedBox onChange={this.handleChange} /> <Label check> Eu li e aceito o termo </Label>
            </div>
          </div>
        </div>
          <SeguirSub width='40vw' unlock={unlock} />

        </section>
      </form>

      </Container>
      </FadeIn>

            
    )
  }
}